export const APP_URLS = {
  SUPPORT: 'info@apphitminchan.com',
};
